import React from 'react'

import { SvgProps } from '../types'
import { Icon } from '../Icon'

export const Sound: React.FC<SvgProps> = (props) => {
  return (
    <Icon height="24" width="24" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M19.114 5.636C19.9497 6.47173 20.6127 7.46389 21.065 8.55583C21.5173 9.64776 21.7501 10.8181 21.7501 12C21.7501 13.1819 21.5173 14.3522 21.065 15.4442C20.6127 16.5361 19.9497 17.5283 19.114 18.364M16.463 8.288C17.4474 9.27254 18.0004 10.6078 18.0004 12C18.0004 13.3922 17.4474 14.7275 16.463 15.712M6.75 8.25L11.47 3.53C11.5749 3.42525 11.7085 3.35392 11.8539 3.32504C11.9993 3.29615 12.15 3.311 12.2869 3.36772C12.4239 3.42443 12.541 3.52045 12.6234 3.64367C12.7058 3.76689 12.7499 3.91176 12.75 4.06V19.94C12.7499 20.0882 12.7058 20.2331 12.6234 20.3563C12.541 20.4796 12.4239 20.5756 12.2869 20.6323C12.15 20.689 11.9993 20.7039 11.8539 20.675C11.7085 20.6461 11.5749 20.5748 11.47 20.47L6.75 15.75H4.51C3.63 15.75 2.806 15.243 2.572 14.396C2.35751 13.6154 2.2492 12.8095 2.25 12C2.25 11.17 2.362 10.367 2.572 9.604C2.806 8.756 3.63 8.25 4.51 8.25H6.75Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}
